import { graphql, useStaticQuery } from 'gatsby';
import { IBlok } from '../types';

export type ICampaignData = {
  posts: {
    edges: {
      node: IBlok;
    }[];
  };
};

const usePreOwnedCampaignData = () => {
  const data: ICampaignData = useStaticQuery(graphql`
    {
      posts: allStoryblokEntry(
        filter: { field_component: { eq: "stock-boats-campaign" } }
      ) {
        edges {
          node {
            id
            uuid
            name
            slug
            full_slug
            content
            created_at
          }
        }
      }
    }
  `);

  return data.posts.edges.map((edge: any) => edge.node);
};

export default usePreOwnedCampaignData;
